import Script from 'next/script';

export const AdaptH5Script = ({ locale }) => {
  // PC -> H5 映射Map
  const routeMap = {
    // lending首页 -> H5引导页
    '/trade/spot/lending': `/${locale}/trade/spot/lending/guide`,
  };

  return (
    <Script
      id="adapt-h5"
      strategy="beforeInteractive"
      dangerouslySetInnerHTML={{
        __html: `
      // 是否手机端
      var isMobile = /(ipod|ipad|iphone|android|mobile)/.test(navigator.userAgent.toLowerCase());

      // 获取当前页面去掉语言后的路径，用作匹配
      var pathname = location.pathname.replace('/${locale}', '');

      // 获取匹配到的H5路径
      var h5Path = ${JSON.stringify(routeMap)}[pathname];

      // 匹配跳转H5
      if (isMobile && h5Path) {
        location.assign(h5Path);
      }
      `,
      }}
    />
  );
};
